module.exports = __webpack_public_path__ + "static/img/iptu.caeacee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loja/iptu.png
// module id = 836
// module chunks = 0